export default __webpack_public_path__ + "img/align-center.979ca664.svg";